<div class="hub-calendar">

    <div *ngIf="isShowMoreSearchOptions" class="hub-search-more">
        <div class="hub-search-more-wrap">
            <p>Can't find what you're looking for? Click
                <span #searchMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="searchOptionsMenu"
                    class="search-more">HERE</span>
                to explore more options.
            </p>

            <mat-menu #searchOptionsMenu="matMenu" class="search-options-menu" igClickStopPropagation>
                <div class="p-4" igClickStopPropagation>
                    <div class="flex flex-col gap-2" igClickStopPropagation>
                        <b>Search From</b>
                        <div *ngFor="let option of ['name', 'address', 'category', 'description']"
                            igClickStopPropagation>
                            <mat-checkbox [(ngModel)]="searchOptions[option]" igClickStopPropagation>
                                {{ option | titlecase }}
                            </mat-checkbox>
                        </div>
                        <button mat-raised-button color="primary" [disabled]="!hasSelectedOptions"
                            (click)="applySearchOptions(searchMenuTrigger)" class="mt-3">
                            SEARCH MORE
                        </button>
                    </div>
                </div>
            </mat-menu>

        </div>
    </div>

    <ig-water-fall-container #waterFallContainer [hidden]="isNoContent" [itemWidth]="270" [maxColumnCount]="6"
        [isAllItemsLoaded]="isAllDataLoaded" (onLoadMore)="loadMore()"
        [ngStyle]="{'top':isShowMoreSearchOptions?'6rem':'0','height':isShowMoreSearchOptions?'calc(100% - 7rem)':'100%'}"
        style="transition:all 0.3s">

        <ng-container *ngIf="actionCommand.isEventCalendar">
            <ig-hub-event-card *ngFor="let event of events" [event]="event"
                [isItineraryOn]="featuresToggle.itinerary"></ig-hub-event-card>
        </ng-container>
        <ng-container *ngIf="!actionCommand.isEventCalendar">
            <ig-hub-place-card *ngFor="let place of places"
                [notAllowed]="actionCommand.queryParams.noFilter&&notAllowed(place)" [place]="place"
                [isItineraryOn]="featuresToggle.itinerary" [searchFields]="searchFields"></ig-hub-place-card>
        </ng-container>

    </ig-water-fall-container>

    <ng-container>
        <ig-page-spinner #spinner></ig-page-spinner>
    </ng-container>

    <ig-no-content *ngIf="isNoContent"></ig-no-content>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/calendar/hub.calendar.component.html